import { injectFontFallbacks } from './inject-font-fallbacks';
export var applyFontFallbacksString = function (fontFamily) {
    return injectFontFallbacks(fontFamily);
};
//# sourceMappingURL=apply-font-fallbacks-string.js.map